import { Request } from "./HttpService";

export const iframeService = {
  getDashBoard() {
    return Request("vitae/iframe/dashboard", "GET");
  },
  GetProposalByStatus(status) {
    return Request(`vitae/iframe/proposal/status/${status}`);
  },
  getProposalByEmail(candidateEmail) {
    return Request(`vitae/iframe/proposal/email/${candidateEmail}`);
  },
  getProjectEstimationbyInterviewId(interviewId) {
    return Request(`vitae/iframe/projectEstimation/${interviewId}`);
  },
  getProjectEstimationByHash(hash, interviewId) {
    return Request(`vitae/iframe/projectEstimation/${hash}/${interviewId}`);
  },
  // getRiseProjectEstimationByHash(hash) {
  //   return Request(`vitae/iframe/projectEstimation/${hash}`);
  // },
  getProjectEstimation() {
    return Request(`vitae/iframe/projectEstimation`);
  }
};
